import React, { useContext, useState } from "react";
import { useLocation } from "react-router-dom";
import { BlueButton, WhiteButton } from "../../../../components/ui/Buttons";
import { UserContext } from "../../../../context/user";
import { downloadCSVFile } from "../../../../util/downloadCSVFile";
import Toast from "../../../../components/portal/Toast";
import ModalV2 from "@/components/portal/ModalV2";
import { ClientSelectV2 } from "@/lib/clients/ClientSelectV2";
import { Client } from "@/types/userManagement";

function ExportFacilities() {
  const user = useContext(UserContext);

  const [clientPopup, setClientPopup] = useState<boolean>(false);
  const [selectedClient, setSelectedClient] = useState<Client | undefined>(undefined);
  const [success, setSuccess] = useState<{
    code: number;
    message: string;
  } | null>(null);
  const [toast, setToast] = useState<boolean>(false);
  const pathname = useLocation().pathname.split("/");
  const isSuperAdmin = user?.role.auroraAccessLevel === "all";

  const handleExportClick = () => {
    if (isSuperAdmin) {
      setClientPopup(true);
    } else {
      downloadCSVFile(
        `${process.env.REACT_APP_API_URL}facilities-export-csv`,
        "facilities.csv"
      );
    }
  };

  const handleSuperAdminExport = () => {
    const url = selectedClient
      ? `${process.env.REACT_APP_API_URL}facilities-export-csv?clientID=${selectedClient.id}`
      : `${process.env.REACT_APP_API_URL}facilities-export-csv`;
    downloadCSVFile(
      url,
      "facilities.csv",
      (response) => {
        setClientPopup(false);
        setSuccess({ code: response.status, message: "Downloaded facilities CSV file." });
        setToast(true);
      },
      (error) => {
        setClientPopup(false);
        setSuccess({ code: error.status, message: error.statusText });
        setToast(true);
      }
    );
  };

  return (
    <div className="w-full">
      {!pathname.includes("facilities") ? (
        <WhiteButton text="Export Facilities" onClick={handleExportClick} />
      ) : (
        <BlueButton text="Export Facilities" onClick={handleExportClick} />
      )}
      <ModalV2 open={clientPopup} setOpen={setClientPopup} contentClassName="w-full max-w-md">
        <div className="flex flex-col gap-4">
          <span className="text-lg mx-auto">Export Facilities</span>
          <ClientSelectV2 onChange={setSelectedClient} />
          <BlueButton text="Export Facilities" onClick={handleSuperAdminExport} />
        </div>
      </ModalV2>

      <Toast open={toast} setOpen={setToast} setSuccess={setSuccess}>
        {success?.code !== 200 ? (
          <span className="text-lg font-semibold">Error: {success?.code}</span>
        ) : null}

        {success?.code === 200 ? <span>Facilities exported.</span> : null}

        {success?.code !== 200 ? (
          <p className="my-4">{success?.message}</p>
        ) : null}
      </Toast>
    </div>
  );
}

export default ExportFacilities;
